import { makeElement } from '../../../common/Utils';
import { DATA_AREA, DATA_CONTENTS } from '../socials/GA360';

export abstract class AbsSocial {
  protected ElBtn!: HTMLElement;
  abstract name: SocialName;
  abstract dataContents: string;
  abstract dataArea: string;

  constructor(
    protected ElShareItemWrap: HTMLElement,
    protected option: ShareOption
  ) {}

  // init
  protected init() {
    // 버튼 템플릿 만들고
    this.makeElBtn();
    // 이벤트 붙이고
    this.addEvent();
    // Ulist에 버튼 템플릿 붙이기
    this.appendElBtn();
  }

  abstract callShare(): Promise<void>;

  // 이벤트 붙이기
  addEvent() {
    this.ElBtn.addEventListener('click', async (e) => {
      try {
        await this.option.beforeShareAsync();
        await this.callShare();
        await this.option.afterShareAsync({ name: (e.target as HTMLElement).dataset["name"] as SocialName });
      } catch {
        return;
      }
    });
  }

  // 템플릿 만들기
  makeElBtn() {
    this.ElBtn = makeElement(`
            <button  data-name="${this.name}" ${DATA_CONTENTS}="${this.dataContents}" ${DATA_AREA}="${this.dataArea}">
                ${this.name}
            </button>
        `);
  }

  // 템플릿 붙이기
  appendElBtn() {
    this.ElShareItemWrap.appendChild(this.ElBtn);
  }
}
